export default "__VITE_ASSET__DZIUw8rD__"